import { FC } from "react"
import { SchedulesAdd } from "../../../../module/schedules/containers/add"

export const SchedulesAddUserPage: FC = () => <SchedulesAdd />
